import { Alert, AlertIcon, Box, Heading, Text, VStack } from '@chakra-ui/react'; // Removed Spinner for now
import FsmLayout from '@components/layout/layout/DefaultLayout/fsm/FsmLayout';
import OzempicChatInterface from '@components/ozempicChat/OzempicChatInterface'; // Will be created next
import { useSem } from '@contexts/SemContextProvider';
import Head from 'next/head';
import React from 'react';

const OzempicFinderPage: React.FC = () => {
  const { dynamicPhoneNumber } = useSem();

  const phoneNumberString = dynamicPhoneNumber ? String(dynamicPhoneNumber) : undefined;

  return (
    <FsmLayout>
      <Head>
        <title>Ozempic AI Chat - Fair Square Medicare</title>
        <meta name="description" content="Ask our AI assistant your questions about Ozempic and Medicare." />
      </Head>
      <VStack spacing={8} py={10} px={[4, 6, 8]} align="stretch" maxW="800px" mx="auto">
        <Box textAlign="center">
          <Heading as="h1" size="2xl" mb={4} color="blue.800">
            Ozempic AI Assistant
          </Heading>
          <Text fontSize="xl" color="gray.600" mb={4}>
            Have questions about Ozempic, especially regarding Medicare? Ask our AI assistant!
          </Text>
        </Box>

        {phoneNumberString ? (
          <OzempicChatInterface dynamicPhoneNumber={phoneNumberString} />
        ) : (
          <Alert
            status="warning"
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            height="150px"
            borderRadius="md"
          >
            <AlertIcon boxSize="40px" mr={0} />
            <Text fontSize="lg" mt={3}>
              Chat assistant is currently initializing or contact information is unavailable. Please check back shortly.
            </Text>
          </Alert>
        )}
      </VStack>
    </FsmLayout>
  );
};

export default OzempicFinderPage;
